import { Layout, Menu } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getSidebarData } from "./utils/sidebar";
import { Logo } from "../../assets";
import { LogoutOutlined } from "@ant-design/icons";

const { Sider } = Layout;

const Sidebar = ({ userPermission }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getSidebarData(userPermission));
  }, [userPermission]);

  const signout = () => {
    localStorage.removeItem("accessToken");

    navigate("/");

    window.location.reload();
  };

  return (
    <Sider
      theme="light"
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
      style={{
        height: "100vh",
        overflow: "hidden",
        position: "relative",
        zIndex: 100,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          padding: "10px 0",
        }}
      >
        <div style={{ flexShrink: 0 }}>
          {!collapsed && (
            <div className="px-4 my-2 pb-3 border-bottom text-center">KEPLER</div>
          )}
          {collapsed && (
            <div className="d-flex justify-content-center my-2">
              <img style={{ width: 40 }} src={Logo} alt="logo" />
            </div>
          )}
        </div>
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            minHeight: 0,
            scrollbarWidth: "none",
            msOverflowStyle: "none"
          }}
          className="custom-scrollbar"
        >
          <Menu
            mode="inline"
            style={{
              border: "none",
              height: "100%"
            }}
            items={items.map((item) => ({
              key: item.key,
              icon: item.icon,
              label: <Link to={item.link}>{item.label}</Link>
            }))}
          />
        </div>
        <div style={{ flexShrink: 0, borderTop: "1px solid #f0f0f0" }}>
          <Menu
            mode="inline"
            style={{
              border: "none"
            }}
            items={[
              {
                key: "signout",
                icon: <LogoutOutlined />,
                label: "Выйти",
                className: "text-danger",
                onClick: signout,
              }
            ]}
          />
        </div>
      </div>
    </Sider>
  );
};

export default Sidebar;
